exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".SegmentPopup-2c7dbb1c{width:300px}.SegmentPopup-2c7dbb1c.ultrawide-a8d4f82d{width:350px}.SegmentPopup-2c7dbb1c .metrics-b71ce40b{display:flex;position:relative;flex-wrap:wrap;margin-bottom:-5px}.SegmentPopup-2c7dbb1c .fourCol-055798e3 .col-8796be99{flex:1 1 auto;max-width:25%;min-width:20%;margin-right:10px}.SegmentPopup-2c7dbb1c .col-8796be99{flex:1 1 32%;max-width:33%;min-width:30%}.SegmentPopup-2c7dbb1c .col-8796be99 .metric-c7f719d1{padding-bottom:15px}.SegmentPopup-2c7dbb1c .col-8796be99 .metric-c7f719d1 .value-8958c3a6{font-weight:bold;font-size:14px;margin-bottom:2px}.SegmentPopup-2c7dbb1c .col-8796be99 .metric-c7f719d1 .label-c9dec92f{white-space:nowrap}\n", ""]);

// Exports
exports.locals = {
	"SegmentPopup": "SegmentPopup-2c7dbb1c",
	"ultrawide": "ultrawide-a8d4f82d",
	"metrics": "metrics-b71ce40b",
	"fourCol": "fourCol-055798e3",
	"col": "col-8796be99",
	"metric": "metric-c7f719d1",
	"value": "value-8958c3a6",
	"label": "label-c9dec92f"
};